export default __webpack_public_path__ + "static/media/adobe-photoshop.1924f86c.svg";